import { Dispatch, SetStateAction } from 'react'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Icon, Text, Toggle } from '@/ui'
import { TypographyStyles } from '@/styles'

export const PriorityButton = ({
  icon,
  text,
}: {
  priorities: string[]
  setPriorities: Dispatch<SetStateAction<string[]>>
  name: string
  icon: IconDefinition
  text: string
}) => {
  return (
    <Toggle variant="outline" className="w-[200px] block w-[300px]">
      <Icon icon={icon} size="2x" />

      <Text variant={TypographyStyles.H3} textAlign="center">
        {text}
      </Text>
    </Toggle>
  )
}
